<template>
  <div class="container mx-auto mb-8">
    <div class="buttons flex justify-end mb-4 mr-4 md:mr-0" v-if="$contact.isAllowed('create')">
      <router-link :to="{ name: 'contact-new' }" class="btn btn-sm bg-green-dark">
        Nieuw contact
      </router-link>
    </div>

    <base-table
      class="bg-white"
      type="contact"
      :body="contacts"
      :sort-key="filters.sort"
      :reversed="filters.reverse"
      :actions="{ editable: $contact.isAllowed('update'), removable: $contact.isAllowed('destroy') }"
      @ordered="orderChanged">
    </base-table>

    <base-pagination
      class="bg-white"
      v-if="pagination.last_page > 1"
      :total-pages="pagination.last_page"
      :total="10"
      :current-page="pagination.current_page"
      @page-changed="pageChanged">
    </base-pagination>
  </div>
</template>

<script>
import store from '@/store';
import Contact from '@/store/modules/contact';
import ContactPerimeter from '@/perimeters/contact';

import { mapState } from 'vuex';

if (!store.state.contact) store.registerModule('contact', Contact);

export default {
  name: 'ContactList',
  perimeters: [ContactPerimeter],
  data() {
    return {
      headers: [
        { label: 'Naam', value: 'name', order: true },
        { label: 'Straat', value: 'street', order: true },
        { label: 'Stad', value: 'city', order: true },
        { label: 'Telefoon', value: 'phone', order: true }
      ]
    };
  },
  created() {
    if (!this.contacts.length) {
      this.fetch();
    }
  },
  computed: {
    ...mapState('contact', {
      pagination: state => state.pagination,
      contacts: state => state.items,
      filters: state => state.filters
    })
  },
  methods: {
    pageChanged(page) {
      this.$store.commit('contact/setFilters', { key: 'page', value: page });
      this.fetch();
    },
    orderChanged(key) {
      const reverse =
        this.filters.sort.replace('-', '') == key
          ? !this.filters.reverse
          : false;
      const name = reverse ? `-${key}` : key;

      this.$store.commit('contact/setFilters', {
        key: 'reverse',
        value: reverse
      });

      this.$store.commit('contact/setFilters', { key: 'sort', value: name });
      this.fetch();
    },
    fetch() {
      this.$store.dispatch('contact/fetchAll');
    }
  }
};
</script>
